module.exports = __webpack_public_path__ + "static/media/cameron_baradar.689a17d0.jpeg";